import {
  BasicOverlay,
  BasicOverlayData,
} from "$/game/prefabs/scenes/overlays/BasicOverlay.ts";

export class LoadingOverlay extends BasicOverlay {
  private eggSprite!: Phaser.GameObjects.Image;
  constructor() {
    super({ key: "LoadingOverlay" });
  }

  override create(data: BasicOverlayData) {
    super.create(data);

    this.eggSprite = this.add.image(
      0,
      0,
      this.atlas,
      this.keys.assets.sprites.egg.egg,
    )
      .setOrigin(0.5, 0.5)
      .setPosition(this.cameras.main.width / 2, this.cameras.main.height / 2);
  }

  override update() {
    this.eggSprite.rotation += 0.05;
  }
}
